import PropTypes from 'prop-types'
import { Cell, Pie, PieChart } from 'recharts'

import styles from './Pie.module.scss'

const colors = ['#A281E9', '#E4DCE4']

const SinglePie = ({ data, secondaryLabel }) => {
  return (
    <div className={styles.singlePieContainer}>
      <div className={styles.label}>
        <div className={styles.labelPrimary}>{data[0].value.toFixed(0)}%</div>
        {secondaryLabel && <div className={styles.labelSecondary}>{secondaryLabel}</div>}
      </div>
      <PieChart width={210} height={210}>
        <Pie data={data} innerRadius="70%" outerRadius="100%" dataKey="value">
          {data.map((entry, i) => (
            <Cell key={`cell-${i}`} fill={colors[i]} />
          ))}
        </Pie>
      </PieChart>
    </div>
  )
}
const PieCard = ({ data, title, subtitle, secondaryLabel, children }) => (
  <div className={styles.pieCard}>
    <div className={styles.title}>{title}</div>
    {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    <div className={styles.chartContainer}>
      {data && <SinglePie data={data} secondaryLabel={secondaryLabel} />}
    </div>
    {children}
  </div>
)

PieCard.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string
}

export default PieCard
